import styled, { css } from "styled-components";

interface StyledToastProps {
  // $toastPosition?: string;
  // $fixedToastPosition?: string;
  $isFixed?: boolean;
}

export const StyledToast = styled.div<StyledToastProps>`
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  top: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-use-select: none;
  user-select: none;
  z-index: 10000;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  gap: 0.4rem;

  .toast-box {
    box-shadow: var(--box-shadow);
    position: absolute;
    padding: 0.4rem 1.6rem;
    border-radius: 0.4rem;
    width: max-content;
    display: flex;
    gap: 2rem;
    align-items: center;
    .content-box {
      display: flex;
      gap: 1.6rem;
      align-items: center;
      width: max-content;
      flex-shrink: 0;
      .title-box {
        display: flex;
        align-items: center;
        gap: 0.4rem;
        font: var(--body-small-600);
        .icon {
          width: 1.2rem;
          height: 1.2rem;
          path {
            stroke-width: 1.4;
          }
        }
      }

      .message {
        font: var(--body-small-600);
        color: var(--text-gray-normal);
      }
    }
  }

  .toast-box.success {
    background-color: var(--pri-blue-3);
    .title-box {
      color: var(--pri-blue-7);
      .icon path {
        stroke: var(--pri-blue-7);
      }
    }
  }
  .toast-box.error {
    background-color: var(--sys-red-0);
    .title-box {
      color: #ad0000;
      .icon path {
        stroke: #ad0000;
      }
    }
  }
  .toast-box.info,
  .toast-box.loading {
    &.normal {
      background-color: var(--bg-gray-normal);
      .title-box,
      .message {
        color: var(--text-gray-strong);
        .icon path {
          stroke: var(--text-gray-strong);
        }
      }
    }
    &.strong {
      background-color: var(--bg-gray-strong);
      .title-box,
      .message {
        color: var(--text-gray-normal);
        .icon path {
          stroke: var(--text-gray-normal);
        }
      }
    }
  }
  .toast-box.warning {
    background-color: var(--sec-orange-3);
    .title-box {
      color: var(--sec-orange-6);
      .icon path {
        stroke: var(--sec-orange-6);
      }
    }
  }
  .toast-box.loading {
    .title-box {
      .loading {
        display: flex;
        gap: 0.4rem;
        align-items: center;
        & > p {
          color: var(--pri-blue-4);
          font: var(--body-small-600);
        }
      }
    }
  }

  /* 위에서 나오는 TOAST 메시지 애니메이션 */
  /* 위에서 나오는 TOAST 메시지 애니메이션 */
  /* 위에서 나오는 TOAST 메시지 애니메이션 */
  .toast-item-enter {
    top: -10rem;
  }
  .toast-item-enter-active {
    top: 1.4rem;
  }
  .toast-item-enter-done {
    top: 1.4rem;
  }
  .toast-item-exit {
    top: 1.4rem;
  }
  .toast-item-exit-active {
    top: -10rem;
  }
  .toast-item-exit-done {
    top: -10rem;
  }

  /* FIXED TOAST가 열려있을 경우 더 낮게 내려오는 TOAST 메시지 애니메이션 */
  /* FIXED TOAST가 열려있을 경우 더 낮게 내려오는 TOAST 메시지 애니메이션 */
  /* FIXED TOAST가 열려있을 경우 더 낮게 내려오는 TOAST 메시지 애니메이션 */
  .fixed-item-enter {
    top: 5.6rem;
  }
  .fixed-item-enter-active {
    top: 5.6rem;
  }
  .fixed-item-enter-active {
    top: 5.6rem;
  }
  .fixed-item-enter-done {
    top: 5.6rem;
  }
  .fixed-item-exit {
    top: 5.6rem;
  }
  .fixed-item-exit-done {
    top: 5.6rem;
  }

  /* 이미 TOAST가 열려있는 상태에서 또 다른 TOAST가 열릴 때 기존 TOAST가 사라지는 애니메이션 */
  /* 이미 TOAST가 열려있는 상태에서 또 다른 TOAST가 열릴 때 기존 TOAST가 사라지는 애니메이션 */
  /* 이미 TOAST가 열려있는 상태에서 또 다른 TOAST가 열릴 때 기존 TOAST가 사라지는 애니메이션 */
  .fade-item-enter-active {
    top: 1.4rem;
  }
  .fade-item-enter-done {
    top: 1.4rem;
  }

  /* 이미 TOAST가 열려있는 상태에서 또 다른 TOAST가 열릴 때 기존 TOAST가 사라지는 애니메이션 */
  /* 이미 TOAST가 열려있는 상태에서 또 다른 TOAST가 열릴 때 기존 TOAST가 사라지는 애니메이션 */
  /* 이미 TOAST가 열려있는 상태에서 또 다른 TOAST가 열릴 때 기존 TOAST가 사라지는 애니메이션 */
  .fade-fixed-item-enter-active {
    top: 5.6rem;
  }
  .fade-item-enter-done {
    top: 5.6rem;
  }
  .fade-item-exit {
    top: 5.6rem;
  }
`;
